import { getErrorPayload } from "@application/common/helpers/api-helper";
import PurchaseInvoiceApi from "@infrastructure/purchase-invoice-api";
import { createAsyncThunk } from "@reduxjs/toolkit";
import { addSuccessNotification } from "../common/notificationSlice";
export const getAllPurchaseInvoiceStatusAsync = createAsyncThunk('PurchaseInvoice/GetAllPurchaseInvoiceStatus', async (_, { rejectWithValue }) => {
    try {
        const response = await PurchaseInvoiceApi.getAllPurchaseInvoiceStatus();
        return response.data;
    }
    catch (error) {
        return rejectWithValue(getErrorPayload(error));
    }
});
export const getOrdersListAsync = createAsyncThunk('PurchaseInvoice/GetOrdersList', async (orderNumber, { rejectWithValue, fulfillWithValue }) => {
    try {
        const response = await PurchaseInvoiceApi.getOrdersList(orderNumber);
        return fulfillWithValue(response.data);
    }
    catch (error) {
        return rejectWithValue(getErrorPayload(error));
    }
});
export const getPurchaseInvoiceNumberAsync = createAsyncThunk('seInvoice/PurchaseInvoiceNumber', async (_, { rejectWithValue }) => {
    try {
        const response = await PurchaseInvoiceApi.getPurchaseInvoiceNumber();
        return response.data;
    }
    catch (error) {
        return rejectWithValue(getErrorPayload(error));
    }
});
export const CreatePurchaseInvoiceAsync = createAsyncThunk('PurchaseInvoice/Create', async (createdInvoice, { rejectWithValue, fulfillWithValue, dispatch }) => {
    try {
        const response = await PurchaseInvoiceApi.createPurchaseInvoice(createdInvoice);
        dispatch(addSuccessNotification('Inkoopfacturen succesvol toegevoegd'));
        return fulfillWithValue(response.data);
    }
    catch (error) {
        return rejectWithValue(getErrorPayload(error));
    }
});
export const getPurchaseInvoiceByIdAsync = createAsyncThunk('PurchaseInvoice/GetPurchaseInvoiceById', async (purchaseInvoiceId, { rejectWithValue, fulfillWithValue }) => {
    try {
        const response = await PurchaseInvoiceApi.getPurchaseInvoiceById(purchaseInvoiceId);
        return fulfillWithValue(response.data);
    }
    catch (error) {
        return rejectWithValue(getErrorPayload(error));
    }
});
export const UpdatePurchaseInvoiceAsync = createAsyncThunk('PurchaseInvoice/Update', async (updatedPurchaseInvoice, { rejectWithValue, fulfillWithValue, dispatch }) => {
    try {
        const response = await PurchaseInvoiceApi.updatePurchaseInvoice(updatedPurchaseInvoice);
        dispatch(addSuccessNotification('Inkoopfacturen succesvol bijgewerkt'));
        return fulfillWithValue(response.data);
    }
    catch (error) {
        return rejectWithValue(getErrorPayload(error));
    }
});
export const deletePurchaseInvoiceByIdAsync = createAsyncThunk(`PurchaseInvoice/Delete`, async (id, { rejectWithValue, fulfillWithValue, dispatch }) => {
    try {
        const response = await PurchaseInvoiceApi.deletePurchaseInvoiceById(id);
        dispatch(addSuccessNotification('Record succesvol verwijderd'));
        return fulfillWithValue(response.data);
    }
    catch (error) {
        return rejectWithValue(getErrorPayload(error));
    }
});
export const getAllPurchaseInvoicesAsync = createAsyncThunk('PurchaseInvoice/GetAll', async (request, { rejectWithValue, fulfillWithValue }) => {
    try {
        const response = await PurchaseInvoiceApi.getAllPurchaseInvoices(request);
        return fulfillWithValue(response.data);
    }
    catch (error) {
        return rejectWithValue(getErrorPayload(error));
    }
});
export const generatePurchaseInvoicePdfAsync = createAsyncThunk(`PurchaseInvoice/GeneratePurchaseInvoicePdf`, async (invoicePdfData, { rejectWithValue, fulfillWithValue, dispatch }) => {
    try {
        const response = await PurchaseInvoiceApi.generatePurchaseInvoicePdf(invoicePdfData);
        return response;
    }
    catch (error) {
        return rejectWithValue(getErrorPayload(error));
    }
});
export const downloadPurchaseInvoiceAttachmentAsync = createAsyncThunk(`PurchaseInvoice/DownloadPurchaseInvoiceAttachment`, async (purchaseInvoiceId, { rejectWithValue, fulfillWithValue, dispatch }) => {
    try {
        const response = await PurchaseInvoiceApi.downloadPurchaseInvoiceAttachment(purchaseInvoiceId);
        return response;
    }
    catch (error) {
        return rejectWithValue(getErrorPayload(error));
    }
});
